import { createCrudStore } from "@/store/crudStore";
import { apiService } from "@/services/api";
import db from "@/services/offlineDb";
import { enqueueOp } from "@/services/offlineQueue";

const lotesStore = createCrudStore("lotes_vacas");

export function getDisplayName(lote) {
  if (!lote) return "Área";
  const tipoArea = (lote.tipo_area || "").toLowerCase();
  const tipoSub = (lote.tipo_subdivision || "").toLowerCase();

  if (tipoArea === "parcela") return "Parcela";
  if (tipoArea === "potrero") return "Potrero";
  if (
    tipoArea === "corral" ||
    tipoSub === "corral_engorde" ||
    tipoSub === "enfermeria"
  )
    return "Corral";
  return lote.nombre_lote || "Área";
}

export default {
  ...lotesStore,
  state: {
    ...lotesStore.state,
    contador_por_lote: [],
    contador_total: {
      en_lotes: 0,
      vendidos: 0,
      muertos: 0,
      abortos: 0,
      total_registrados: 0,
    },
  },
  getters: {
    ...lotesStore.getters,
    contador_por_lote(state) {
      return state.contador_por_lote;
    },
    contador_total(state) {
      return state.contador_total;
    },
    getDisplayName: () => (lote) => {
      return getDisplayName(lote);
    },
  },
  mutations: {
    ...lotesStore.mutations,
    setContadorPorLote(state, data) {
      state.contador_por_lote = data;
    },
    setContadorTotal(state, data) {
      state.contador_total = data;
    },
  },
  actions: {
    ...lotesStore.actions,
    getLotes: lotesStore.actions.getAllStates,
    postLote: lotesStore.actions.create,
    deleteLote: lotesStore.actions.delete,

    async patchLote({ dispatch }, payload) {
      if (!navigator.onLine) {
        await enqueueOp(
          "lotes",
          "update",
          payload,
          `/lotes_vacas/editar_estancias_nombres/${payload.lote_id}`,
          "PATCH"
        );
        const existing = await db.lotes
          .where("id")
          .equals(payload.lote_id)
          .first();
        if (existing?.localId) {
          await db.lotes.update(existing.localId, payload).catch(() => {});
        }
        return { status: 200, data: payload };
      }
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.patchCustom(
            `/lotes_vacas/editar_estancias_nombres/${payload.lote_id}`,
            payload
          ),
        errorMessage: "Error al editar el lote",
      });
    },

    async getContadorPorLote({ commit, dispatch }) {
      if (!navigator.onLine) {
        try {
          const localAnimales = await db.animales.toArray();
          const counts = {};
          for (const a of localAnimales) {
            const lid = a.lote_id || a.lote_actual?.lote_id;
            if (lid) {
              counts[lid] = (counts[lid] || 0) + 1;
            }
          }
          const data = Object.entries(counts).map(([lote_id, cantidad]) => ({
            lote_id: parseInt(lote_id, 10),
            cantidad,
            total: cantidad,
          }));
          commit("setContadorPorLote", data);
          return data;
        } catch {
          return [];
        }
      }
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.getCustom("lotes_vacas/contador_por_lote"),
        onSuccessCallback: (commit, data) => {
          commit("setContadorPorLote", data);
        },
        errorMessage: "Error al obtener el contador por lote",
      });
    },

    async getContadorTotal({ commit, dispatch }) {
      if (!navigator.onLine) {
        try {
          const localAnimales = await db.animales.toArray();
          const activos = localAnimales.filter(
            (a) => !a.vendido && a.estado_excepcion !== "muerto"
          ).length;
          const data = {
            en_lotes: activos,
            vendidos: 0,
            muertos: 0,
            abortos: 0,
            total_registrados: localAnimales.length,
          };
          commit("setContadorTotal", data);
          return data;
        } catch {
          return {
            en_lotes: 0,
            vendidos: 0,
            muertos: 0,
            abortos: 0,
            total_registrados: 0,
          };
        }
      }
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.getCustom("lotes_vacas/contador_total"),
        onSuccessCallback: (commit, data) => {
          commit("setContadorTotal", data);
        },
        errorMessage: "Error al obtener el contador total",
      });
    },

    async calcularFcrLote({ dispatch }, { loteId, fechaDesde, fechaHasta }) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.getCustom(
            `lotes_vacas/${loteId}/fcr/calculo?fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}`
          ),
        errorMessage: "Error calculando FCR del lote",
      });
    },

    async fetchFcrHistorial({ dispatch }, loteId) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.getCustom(`lotes_vacas/${loteId}/fcr/historial`),
        errorMessage: "Error cargando historial de FCR",
      });
    },

    async guardarFcrRegistro({ dispatch }, { loteId, payload }) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.postCustom(`lotes_vacas/${loteId}/fcr/registro`, payload),
        errorMessage: "Error guardando registro de FCR",
      });
    },
  },
};
